<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
    >
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动名称">
            <a-input placeholder="请输入活动名称" v-decorator="['activityName']" :disabled="showAct"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item class="time-box" label="活动时间">
            <a-date-picker
                v-decorator="['activityStartTime']"
                :disabled-date="disabledStartDate"
                show-time
                valueFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择活动开始时间"
                @change="startPanelChange"
                :disabled="showAct"
            />
            <a-date-picker
                v-decorator="['activityEndTime']"
                :disabled-date="disabledEndDate"
                show-time
                valueFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择活动结束时间"
                @change="endPanelChange"
                :disabled="showAct"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动类型">
            <a-input placeholder="请输入活动类型" :disabled="showAct" v-decorator="['activityTypeName']"/>

            <!--            />-->
          </a-form-item>
        </a-col>
      </a-row>
<!--      <a-row :gutter="24">-->
<!--        <a-col :span="20">-->
<!--          <a-form-item label="活动类别">-->
<!--            <a-input placeholder="请输入活动类别" :disabled="showAct" v-decorator="['activityCategoryName']"/>-->

<!--            &lt;!&ndash;            <a-select&ndash;&gt;-->
<!--            &lt;!&ndash;                :disabled="showAct"&ndash;&gt;-->
<!--            &lt;!&ndash;                v-decorator="['activityCategory', { rules: [{ required: false, message: '请选择活动类别' }] }]">&ndash;&gt;-->
<!--            &lt;!&ndash;            </a-select>&ndash;&gt;-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--      </a-row>-->
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="车型代码">
            <a-input placeholder="请输入车型代码" :disabled="showAct" :maxLength="20" v-decorator="['carNumber']"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动地点">
            <a-input placeholder="请输入活动地点" v-decorator="['activityPlace']" :disabled="showAct"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="客户窝子">
            <a-input placeholder="请输入客户窝子" v-decorator="['activityWoZi']" :disabled="showAct"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider/>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item class="time-box" label="活动实际时间">
            <a-date-picker
                v-decorator="['acturalStartTime', { rules: [{ false: true, message: '请选择活动实际开始时间' }] }]"
                show-time
                valueFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择实际开始时间"
                @change="startPanelChange"
                :disabled="show"
            />
            <a-date-picker
                v-decorator="['acturalEndTime', { rules: [{ false: true, message: '请选择活动实际结束时间' }] }]"
                show-time
                valueFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择实际结束时间"
                @change="endPanelChange"
                :disabled="show"
            />
          </a-form-item>
        </a-col>

      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="现场订车">
            <a-input-number placeholder="请输入现场订车" v-decorator="['orderCarCount',rules.orderCarCount ]" readonly
                            disabled/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="合同收据">
            <a-upload
                :action="action"
                :headers="headers"
                list-type="picture-card"
                :fileList="myAccountFileList"
                :multiple="true"
                @change="handleChange"
                :remove="removeAccountFile"
            >
              <div>
                <a-icon type="plus"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="实际费用">
            <a-input-number placeholder="请输入实际费用" v-decorator="['activitySumCharge',rules.activitySumCharge ]" readonly
                            disabled/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动说明">
            <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" placeholder="请输入活动说明"
                        v-decorator="['activityDesc',rules.activityDesc ]" :disabled="show"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="客户信息列表" :forceRender="true">
        <clientList ref="clientList" :rowId="rowId"></clientList>
      </a-tab-pane>
      <a-tab-pane key="2" tab="现场照片" :forceRender="true">
        <p v-if="typeDesc">{{ typeDesc }}</p>
        <liveFile ref="liveFile" :fileList="liveFileList" @remove="removeLiveImg" @change="changeLiveFile"
                  :rowId="rowId"></liveFile>
      </a-tab-pane>
      <a-tab-pane key="3" tab="费用信息列表" :forceRender="true">
        <accountInfoList ref="accountInfoList" @changeSumCharge="changeSumCharge" :rowId="rowId"></accountInfoList>
      </a-tab-pane>
    </a-tabs> -->

    <el-tabs class="tabsClass">
      <el-tab-pane label="客户信息列表">
        <clientList ref="clientList" :rowId="rowId"></clientList>
      </el-tab-pane>
      <el-tab-pane label="现场照片">
        <p v-if="typeDesc">{{ typeDesc }}</p>
        <liveFile ref="liveFile" :fileList="liveFileList" @remove="removeLiveImg" @change="changeLiveFile"
                  :rowId="rowId"></liveFile>
      </el-tab-pane>
      <el-tab-pane label="费用信息列表">
        <accountInfoList ref="accountInfoList" @changeSumCharge="changeSumCharge" :rowId="rowId"></accountInfoList>
      </el-tab-pane>
    </el-tabs>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
import api from '@/services/api';
//接口API
import {dataApi} from '@/services/activityManage/activityAccount';
import {dataApi as actDataApi} from '@/services/activityManage/activityList';

//子表--客户列表
import clientList from "@/pages/web/activityManage/activityAccount/poolPop/clientList";
//子表--现场照片
import liveFile from "@/pages/web/activityManage/activityAccount/poolPop/liveFile";
//子表--费用明细
import accountInfoList from "@/pages/web/activityManage/activityAccount/poolPop/accountInfoList";


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    activityName: {
      rules: [{required: false, whitespace: true, message: "请输入活动名称"}]
    },
    activityType: {
      rules: [{required: false, message: "请选择活动类型"}]
    },
    activityPlace: {
      rules: [{required: false, whitespace: true, message: "请输入活动地点"}]
    },
    activityCategoryName: {
      rules: [{required: false, whitespace: true, message: "请输入活动类别"}]
    },
    carNumber: {
      rules: [{required: false, whitespace: true, message: "请输入车型编号"}]
    },
    activityWoZi: {
      rules: [{required: false}]
    },
    activityDesc: {
      rules: [{required: false, whitespace: true, message: "请输入活动说明"}]
    },
    orderCarCount: {
      rules: [{required: false, message: ""}]
    },
    activitySumCharge: {
      rules: [{required: false, message: ""}]
    },

  };
}

function newEntity() {

  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log('不是新增')
  let entity = await dataApi.getFormDetail(rowId); // 活动报账详情
  entity.data = Object.assign(entity.data, entity.data.entity)
  this.accountId = entity.data.accountId
  this.getActDetail(entity.data.activityId);
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  let accountInfoList = await this.getChildDataNew('accountInfoList');//字表数据

  let params = {
    delScrmActivityAccountDtlList: [],
    delScrmActivityAccountImgList: [],
    entity: {},
    scrmActivityAccountDtlList: [],
    scrmActivityAccountImgList: []
  }
  params.entity = entities;
  params.entity.accountFile = this.accountFileList.map(item => item.imgUrl).join(',')
  params.delScrmActivityAccountDtlList = accountInfoList.del.map(item => item.dtlId)
  params.delScrmActivityAccountImgList = this.removeImgList
  params.scrmActivityAccountDtlList = accountInfoList.child
  params.scrmActivityAccountImgList = this.liveFileList.map(item => {
    return Object.assign({
      "accountId": '',
      "imgUrl": "",
      "remark": "",
      "seqId": ''
    }, item)
  })

  params.entity.accountId = vm.accountId; //更新--没拼错，数据库就是这个字段
  params.entity.activityId = vm.actId; //更新--没拼错，数据库就是这个字段
  if (params.entity.accountId) {
    return await dataApi.saveFormDetail(params, true);
  } else {
    return await dataApi.saveFormDetail(params, false);
  }

}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  this.setRefsValue({
    accountInfoList: entity.scrmActivityAccountDtlList,
    clientList: entity.signList,
  })
  if (entity.entity.accountFile) {
    this.accountFileList = entity.entity.accountFile.split(',').map((item, index) => {
      return {uid: -index, name: 'item_' + index, url: `${api.temp.FILE_PATH}/${item}`, imgUrl: item}
    })
  }
  this.myAccountFileList = this.accountFileList
  this.liveFileList = entity.scrmActivityAccountImgList
  this.liveFileList.forEach(item => {
    item.uid = item.seqId;
    item.name = item.imgUrl;
    item.status = 'done';
    item.url = `${api.temp.FILE_PATH}/${item.imgUrl}`
  })
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['actId'],
  components: {
    accountInfoList,
    clientList,
    liveFile,
  },
  data() {
    return {
      accountId: '',
      action: api.temp.UPLOAD_PATH,//上传文件接口
      headers: {
        token: localStorage.getItem('token') || ''
      },
      actDetail: {},//活动详情
      activityNo: '',//活动编号
      show: false,
      showAct: true,
      startValue: null,
      endValue: null,
      liveFileList: [],//现场照片
      accountFileList: [],//合同收据
      myAccountFileList: [],//合同收据
      removeImgList: [],//删除的现场照片
      typeDesc: '', //现场照片描述
    }
  },
  mounted() {
    if (this.actId) {
      console.log('是新增')
      this.getActDetail(this.actId);
    }
  },
  methods: {
    newEntity,
    loadEntity,
    loadBaseData,
    save,
    afterLoad,
    getRulesTemplate,
    startPanelChange(value) {
      this.startValue = new Date(value).valueOf()
    },
    endPanelChange(value) {
      this.endValue = new Date(value).valueOf()
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      const monthTime = this.getMonthTime(endValue)
      if (!startValue || !endValue) {
        return false;
      }
      return (startValue.valueOf() <= monthTime[0] || startValue.valueOf() >= endValue.valueOf());
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      const monthTime = this.getMonthTime(startValue)
      if (!endValue || !startValue) {
        return false;
      }
      return (startValue.valueOf() >= endValue.valueOf() || endValue.valueOf() >= monthTime[1]);
    },
    getMonthTime(value) {
      if (!value) {
        return false;
      }
      let time = new Date(value);//当前月 要计算其他时间点自己传入即可
      let year = time.getFullYear();
      let month = parseInt(time.getMonth() + 1);

      //开始时间 时间戳
      let start = new Date(year + "-" + month + "-01 00:00:00").getTime()
      //结束时间 时间戳
      if (month == 12) {
        //十二月的时候进位，这里直接用加减法算了
        //也可以用 time.setMonth( month + 1 )去计算并获取结束时间的月份和年份
        month = 0;
        year += 1;
      }
      let end = new Date(year + "-" + (month + 1) + "-01 00:00:00").getTime()
      return [start, end]
    },

    //获取活动详情
    async getActDetail(actId) {
      let actEntity = await actDataApi.getFormDetail(actId);
      this.typeDesc = actEntity.data.typeDesc; //现场照片提示
      actEntity.data.orderCarCount = 0;
      actEntity.data.signList.forEach(item => {
        actEntity.data.orderCarCount = actEntity.data.orderCarCount + item.orderNum
      })
      this.setRefsValue({
        clientList: actEntity.data.signList,
      })
      this.form.setFieldsValue(actEntity.data);
    },

    //合同收据上传
    handleChange(info) {
      if (info.file.status === "done") {
        this.accountFileList.push(Object.assign({}, info.file.response.data, {
          name: info.file.name,
          uid: info.file.uid,
          status: info.file.status,
          imgUrl: info.file.response.data.url,
          url: `${api.temp.FILE_PATH}${info.file.response.data.url}`
        }))
      }
      this.myAccountFileList = info.fileList
    },
    //子组件上传文件回调
    changeLiveFile(info) {
      if (info.file.status === 'done') {
        this.liveFileList.push(Object.assign({}, info.file.response.data, {
          name: info.file.name,
          uid: info.file.uid,
          status: info.file.status,
          imgUrl: info.file.response.data.url,
          url: `${api.temp.FILE_PATH}${info.file.response.data.url}`
        }))
      }
    },
    //修改子表的同时更新主表的费用
    async changeSumCharge() {
      let accountInfoList = await this.getChildDataNew('accountInfoList');//字表数据
      let activitySumCharge = 0;
      accountInfoList.child.forEach(item => {
        activitySumCharge = activitySumCharge + Number(item.sum)
      })
      this.form.setFieldsValue({
        activitySumCharge: activitySumCharge,
      });
    },
    //删除现场照片
    removeLiveImg(info) {
      if (info.seqId) {
        this.removeImgList.push(info.seqId)
      }
      this.liveFileList.forEach((item, index) => {
        if (item.uid === info.uid) {
          this.liveFileList.splice(index, 1)
        }
      })
    },
    //删除合同收据
    removeAccountFile(file) {
      this.accountFileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.accountFileList.splice(index, 1)
        }
      })
      this.myAccountFileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.myAccountFileList.splice(index, 1)
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
.time-box {
  .ant-calendar-picker {
    width: 47%;

    &:first-child {
      margin-right: 6%;
    }
  }
}
</style>
